module.exports = __webpack_public_path__ + "media/images/flags/sb-2c405bb603253b6e2040a62b6b417b90.svg";